import React from 'react'
import Header from '../headerone/Main'
import Bredcom from '../Bredcom/Main'
import BredcomSlider from '../Bredcom/MainSlider'
import NewMain from '../headerone/newMain'



function RTI() { 
  return (
    <>
    
      <NewMain />
        <Bredcom title="Home" subtitle="RTI" />
        <section className="about-area about-p pt-60 pb-60 p-relative fix">
          <div className="container">
            <h2 class="text-center"> We are coming soon </h2>
            <br/>
          </div>
          
        </section>
    </>
  )
}

export default RTI